/**
 * Design Tokens - Colores
 * Paleta de colores centralizada para toda la aplicación
 * Usar estos tokens en lugar de colores hardcodeados
 */

// Colores primarios (se sobreescriben con tema de sucursal)
export const primaryColors = {
  default: '#1890ff',
  light: '#40a9ff',
  dark: '#096dd9',
  lighter: '#e6f7ff',
  darker: '#0050b3',
};

// Colores semánticos (estado)
export const semanticColors = {
  success: '#52c41a',
  successLight: '#95de64',
  successBg: '#f6ffed',
  
  warning: '#faad14',
  warningLight: '#ffc53d',
  warningBg: '#fffbe6',
  
  error: '#ff4d4f',
  errorLight: '#ff7875',
  errorBg: '#fff2f0',
  
  info: '#1890ff',
  infoLight: '#69c0ff',
  infoBg: '#e6f7ff',
};

// Colores de texto
export const textColors = {
  primary: 'rgba(0, 0, 0, 0.88)',
  secondary: 'rgba(0, 0, 0, 0.65)',
  tertiary: 'rgba(0, 0, 0, 0.45)',
  disabled: 'rgba(0, 0, 0, 0.25)',
  inverse: '#ffffff',
  
  // Dark mode
  darkPrimary: 'rgba(255, 255, 255, 0.88)',
  darkSecondary: 'rgba(255, 255, 255, 0.65)',
  darkTertiary: 'rgba(255, 255, 255, 0.45)',
};

// Colores de fondo
export const backgroundColors = {
  // Light mode
  layout: '#f0f2f5',
  container: '#ffffff',
  elevated: '#ffffff',
  
  // Dark mode
  darkLayout: '#1f1f1f',
  darkContainer: '#141414',
  darkElevated: '#262626',
  
  // Otros
  overlay: 'rgba(0, 0, 0, 0.45)',
  transparent: 'transparent',
};

// Colores de bordes
export const borderColors = {
  default: '#d9d9d9',
  light: '#f0f0f0',
  dark: '#434343',
  strong: '#8c8c8c',
};

// Colores por rol (para badges, tags, etc.)
export const roleColors = {
  OWNER: '#722ed1',
  ADMIN_LOCAL: '#1890ff',
  MANAGER: '#13c2c2',
  EMPLOYEE: '#52c41a',
  CAJERO: '#eb2f96',
  METER: '#fa8c16',
  WAITER: '#2f54eb',
  RECEIVER: '#a0d911',
  DRIVER: '#f5222d',
  VIEWER: '#8c8c8c',
};

export default {
  primary: primaryColors,
  semantic: semanticColors,
  text: textColors,
  background: backgroundColors,
  border: borderColors,
  roles: roleColors,
};
